import type { TranslateFunc } from 'src/components/translate';
import type {
  ProductCollectionFilter,
  ProductCollectionNameSearchFilter,
} from 'src/types';

function isNameSearchFilter(
  x: ProductCollectionFilter
): x is ProductCollectionNameSearchFilter {
  return x.__typename === 'ProductCollectionNameSearchFilter';
}

export const formatFilterFn = ({
  filter,
  t,
}: {
  filter: ProductCollectionFilter;
  t: TranslateFunc;
}): { title?: string; value: string; key: string } => {
  if (isNameSearchFilter(filter)) {
    return {
      title: '',
      value: `"${filter.query}"`,
      key: filter.query,
    };
  }

  let value = filter.property;
  switch (filter.__typename) {
    case 'ProductCollectionTermsFilter': {
      const values = Array.isArray(filter.values)
        ? filter.values.map((v, index) =>
            v === '' ? filter.ids[index] || '?' : v
          )
        : filter.ids;
      value =
        values.length > 3
          ? `${values.slice(0, 2).join(', ')}, +${values.length - 2}`
          : values.join(', ');
      break;
    }
    case 'ProductCollectionTermFilter':
      value = filter.value || filter.id;
      break;
    case 'ProductCollectionRangeFilter': {
      const ranges =
        filter.from === filter.to
          ? `${filter.from}`
          : `${filter.from} - ${filter.to}`;
      value = `${ranges}${filter.unit ? ` ${filter.unit}` : ''}`;
      break;
    }
    case 'ProductCollectionRangeGroupFilter': {
      const values = Array.isArray(filter.values) ? filter.values : [filter.id];
      value = values.join(', ');
      break;
    }
    case 'ProductCollectionBooleanFilter':
      value = t(
        'filter',
        filter.id === 'true'
          ? `properties.select-true`
          : `properties.select-false`
      );
      break;
    default:
  }

  return {
    title: filter.title ?? undefined,
    value,
    key: value,
  };
};
